import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesWarehouseArrivedParcelMain } from './modules/ui/Main';

const WarehouseArrivedParcelPage = (
  <SuspensePage>
    <PagesWarehouseArrivedParcelMain />
  </SuspensePage>
);

export default WarehouseArrivedParcelPage;
